import { AsyncPipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { FacettenResetService } from '../../services/facetten/facetten-reset.service';
import { ErweiterteSucheService } from '../../services/filter/erweiterte-suche.service';
import { LoaderService } from '../../services/loader.service';
import { ScreenSizeService, ViewMode } from '../../services/screen-size/screen-size.service';
import { BildungsbereichService } from '../../services/state/bildungsbereich.service';
import { ModalPopupComponent } from '../modal/modal-popup/modal-popup.component';
import { AnbieterFacetteComponent } from './anbieter-facette/anbieter-facette.component';
import { BarrierefreiheitFacetteComponent } from './barrierefreiheit-facette/barrierefreiheit-facette.component';
import { BeginnterminFacetteComponent } from './beginntermin-facette/beginntermin-facette.component';
import { DauerFacetteComponent } from './dauer-facette/dauer-facette.component';
import { ErweiterteSucheToggleComponent } from './erweiterte-suche-toggle/erweiterte-suche-toggle.component';
import { FacettenSlideInComponent } from './facetten-slide-in/facetten-slide-in.component';
import { FilterZuruecksetzenComponent } from './filter-zuruecksetzen/filter-zuruecksetzen.component';
import { FoerderartFacetteComponent } from './foerderart-facette/foerderart-facette.component';
import { KostenFacetteComponent } from './kosten-facette/kosten-facette.component';
import { modalPopups } from './modalIdData';
import { OrtFacetteComponent } from './ort-facette/ort-facette.component';
import { UmkreisFacetteComponent } from './umkreis-facette/umkreis-facette.component';
import { DigitaleLernformFacetteComponent } from './unterrichtsform-facette/digitale-lernform-facette/digitale-lernform-facette.component';
import { FernunterrichtFacetteComponent } from './unterrichtsform-facette/fernunterricht-facette/fernunterricht-facette.component';
import { KombinierteLernformFacetteComponent } from './unterrichtsform-facette/kombinierte-lernform-facette/kombinierte-lernform-facette.component';
import { UnterrichtsformFacetteComponent } from './unterrichtsform-facette/unterrichtsform-facette.component';
import { VorortFacetteComponent } from './unterrichtsform-facette/vorort-facette/vorort-facette.component';
import { UnterrichtszeitFacetteComponent } from './unterrichtszeit-facette/unterrichtszeit-facette.component';
import { WeiterbildungsartFacetteComponent } from './weiterbildungsart-facette/weiterbildungsart-facette.component';

@Component({
  selector: 'now-wbsuche-lib-facetten',
  templateUrl: './facetten.component.html',
  styleUrls: ['./facetten.component.scss'],
  imports: [
    NgTemplateOutlet,
    FacettenSlideInComponent,
    NgClass,
    OrtFacetteComponent,
    UmkreisFacetteComponent,
    FoerderartFacetteComponent,
    BeginnterminFacetteComponent,
    UnterrichtszeitFacetteComponent,
    DauerFacetteComponent,
    UnterrichtsformFacetteComponent,
    VorortFacetteComponent,
    FernunterrichtFacetteComponent,
    DigitaleLernformFacetteComponent,
    KombinierteLernformFacetteComponent,
    KostenFacetteComponent,
    WeiterbildungsartFacetteComponent,
    AnbieterFacetteComponent,
    BarrierefreiheitFacetteComponent,
    FilterZuruecksetzenComponent,
    ErweiterteSucheToggleComponent,
    ModalPopupComponent,
    AsyncPipe
  ]
})
export class FacettenComponent {
  private readonly erweiterteSucheService = inject(ErweiterteSucheService);
  private readonly screenSizeService = inject(ScreenSizeService);
  private readonly loaderService = inject(LoaderService);
  private readonly facettenResetService = inject(FacettenResetService);

  public erweiterteSucheActive$ = this.erweiterteSucheService.erweiterteSucheActive$;
  public modalPopups = modalPopups;
  public bildungsbereichService = inject(BildungsbereichService);

  @Input()
  postleitzahl?: string;

  isDesktop$ = this.screenSizeService.rangeFrom$(ViewMode.DESKTOP);

  loading$: Observable<boolean> = this.loaderService.bildungsangeboteLoading$;

  public async setzeFilterZurueck() {
    await this.facettenResetService.resetFilter();
  }
}
